import { Varsling } from "../../../models";
import RequestService from '../requestService';
import { client } from '../../client';
export default class VarslingService extends RequestService<Varsling, 'varsling'>
{
    SendTestEpost = async () =>
        client.post<void>(`${this.serviceName}/SendTestEpost`, null);
}